import { useNavigate, useLocation, Navigate } from "react-router-dom";
import React, { useState, useEffect, useRef } from 'react';
import { addDoc, collection, query, where, onSnapshot, doc, setDoc, getDocs, limit, orderBy } from "firebase/firestore";
import Cookies from "js-cookie";
import { db } from "../../firebase.js";
import logo_default from "../../assets/logo_default.jpg";
import { Randomcode } from "../../components_root/rendom_code.js";
import { Toast } from '../../components_root/ToastContext.jsx';
import { RiBankFill } from "react-icons/ri";
import CopyUID from "../../components_root/copyuid.jsx";
import { Ledger_accounts_balance } from "../../accounting_root/ledger_accounts_root/ledger_account_balance.js";
export const seo = {
    title: "aooz Services | Free & Premium Online Tools for Productivity, SEO & File Conversion",
    Description: "Discover aooz's free and premium online services including word counter, image to PDF, favicon generator, SEO analyzers, text utilities, and more. Enhance productivity with powerful tools for students, writers, developers, and businesses.",
    keywords: "aooz services, free online tools, premium tools, seo tools, text utilities, file converters, image to pdf, favicon generator, word counter, productivity tools, online converters",
    url: "https://aooz.in/services",
    image: "https://aooz.in/assets/logo.png"
};
export default function Ledger_accounts_profile({ accountguid }) {
    const [accounts_name, setAccounts_name] = useState("");
    const [description, setDescription] = useState("");
    const [mobile, setMobile] = useState("");
    const { Toastshow } = Toast();
    const [IsLoading2, setIsLoading2] = useState(true);
    const navigate = useNavigate();
    const [slug, setSlug] = useState("");
    const [account_data, setAccount_data] = useState([]);
    const [account_ledgerdata, setAccount_ledgerdata] = useState();
    const servicetablename = "accountingfinancedb";
    const fetch_accounts = async () => {
        if (!accountguid) return;

        const select_company_uid = Cookies.get("select_company_uid");
        if (!select_company_uid) return;

        setIsLoading2(true);

        const ledgerQuery = query(
            collection(db, servicetablename, select_company_uid, "ledger_account"),
            where("accountguid", "==", accountguid)
        );

        const unsubscribe = onSnapshot(
            ledgerQuery,
            async (snapshot) => {
                const ledgerDocs = snapshot.docs;

                const mergedData = await Promise.all(
                    ledgerDocs.map(async (docSnap) => {
                        const ledgerData = { id: docSnap.id, ...docSnap.data() };

                        // fetch account info from accounts/{accountguid}
                        const accountDoc = await getDocs(
                            query(collection(db, "accounts"), where("guid", "==", accountguid))
                        );

                        let accountInfo = {};
                        if (!accountDoc.empty) {
                            accountInfo = {
                                account_id: accountDoc.docs[0].id,
                                ...accountDoc.docs[0].data(),
                            };
                        }

                        return {
                            ...ledgerData,
                            account_info: accountInfo, // merged here
                        };
                    })
                );

                setAccount_data(mergedData);
                setIsLoading2(false);
                load_balance(accountguid);
            },
            (error) => {
                console.error("Error fetching accounts:", error);
                setIsLoading2(false);
            }
        );

        return () => unsubscribe();
    };

    const [balance, setBalance] = useState(null);
    const load_balance = async (accountguid) => {
        const res = await Ledger_accounts_balance(accountguid);
        if (res.success) {
            setBalance(res.balance);
        } else {
            setBalance(0);
        }
    };
    useEffect(() => {
        fetch_accounts();
    }, [accountguid]);
    //
    const normalize = (slug = "") => {
        return slug
            .replace(/^https?:\/\//i, "")   // remove http:// or https://
            .replace(/\/+$/, "")            // remove trailing slash
            .replace(/[^a-zA-Z0-9]/g, "")   // remove ALL special characters
            .toLowerCase();                 // make lowercase
    };
    return (
        <div >
            <div  >
                <table>
                    <tr>
                        <td>
                            <table>
                                <tr>
                                    <td >
                                        <img className="icon-photo items-back-fill"
                                            src={
                                                account_data?.[0]?.account_info?.photoURL ||
                                                account_data?.[0]?.logo_url ||
                                                logo_default
                                            }
                                         
                                            onError={(e) => {
                                                e.currentTarget.src = logo_default;
                                            }}
                                        />
                                    </td>
                                </tr>
                                <tr>
                                    <td>
                                        <div
                                            className={
                                                ` text-h3 fcap bold ` +
                                                (account_data[0]?.account_type === "cashier" ? "button-ui red-back" : "button-ui2")
                                            }
                                        >
                                            {account_data[0]?.account_type.replaceAll("_", " ")}
                                        </div>
                                    </td>
                                </tr>

                            </table>

                        </td>
                        <td>
                            <table>
                                <tr>
                                    <td className="text-h2 bold">
                                        {account_data[0]?.account_info?.name || "N/A"}
                                    </td>
                                </tr>


                                <tr className="flex">
                                    <td className="text-h3 text-off">
                                        <table>
                                            <tr>
                                                <td>#{account_data[0]?.accountnumber || "N/A"}</td>
                                                <td width={30}><CopyUID id={account_data[0]?.accountnumber} /></td>
                                            </tr>
                                        </table>
                                    </td>
                                </tr>
                                <tr>
                                    {account_data?.[0]?.mobile &&
                                        account_data?.[0]?.mobile.length >= 10 && (
                                            <td width={100} className="text-h2 text-off">
                                                <table >
                                                    <tr>
                                                        <td >{account_data[0]?.account_info?.code}{account_data[0]?.account_info?.mobile || "N/A"}</td>
                                                        <td width={30}><CopyUID id={account_data[0]?.mobile || account_data[0]?.account_info?.mobile || "N/A"} /></td>
                                                    </tr>
                                                </table>
                                            </td>
                                        )
                                    }
                                </tr>

                            </table>
                        </td>
                    </tr>
                </table>

            </div>
        </div >
    );
}
